import { useEffect, useRef, useState } from "react";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import { useNavigate } from "react-router-dom";
import expenseCategoryService from "../../services/ExpenseCategoryService";

export default function ExpenseCategoryAddPage() {
    const [mounted, setMounted] = useState(false);
    useEffect(() => { setMounted(true); }, []);
    const [name, setName] = useState("");
    const [description, setDescription] = useState("");
    const [loading, setLoading] = useState(false);
    const toast = useRef(null);
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!name.trim()) {
            toast.current.show({
                severity: "warn",
                summary: "Uyarı",
                detail: "Başlık adı boş olamaz!",
            });
            return;
        }

        try {
            setLoading(true);
            const res = await expenseCategoryService.create({ name, description });
            const result = res.data || res;
            if (result.success) {
                toast.current.show({
                    severity: "success",
                    summary: "Başarılı",
                    detail: "Gider başlığı eklendi.",
                });
                setTimeout(() => navigate("/expenses/categories"), 1500);
            } else {
                toast.current.show({
                    severity: "error",
                    summary: "Hata",
                    detail: result.message || "Hata oluştu!",
                });
            }
        } catch (error) {
            toast.current.show({
                severity: "error",
                summary: "Hata",
                detail: "İşlem başarısız!",
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="p-2 md:p-6 bg-slate-50 min-h-screen">
            <Toast ref={toast}  appendTo={mounted ? document.body : "self"} />
            <div className="max-w-2xl mx-auto">
                <div className="bg-white rounded-3xl shadow-xl shadow-slate-200/60 border border-slate-100 overflow-hidden">
                    <div className="!bg-emerald-600 p-6 md:p-8 text-white relative overflow-hidden">
                        <div className="absolute top-0 right-0 w-32 h-32 bg-white/10 rounded-full -mr-16 -mt-16 blur-3xl"></div>
                        <div className="relative z-10 flex items-center gap-4">
                            <div className="w-12 h-12 bg-white/20 backdrop-blur-md rounded-2xl flex items-center justify-center">
                                <i className="pi pi-plus text-2xl"></i>
                            </div>
                            <div>
                                <h1 className="text-2xl font-black uppercase tracking-tight">Yeni Gider Başlığı</h1>
                                <p className="text-emerald-100 text-sm font-medium">Giderlerinizi kategorize etmek için yeni bir başlık tanımlayın.</p>
                            </div>
                        </div>
                    </div>

                    <form onSubmit={handleSubmit} className="p-6 md:p-8 space-y-6">
                        <div className="space-y-2">
                            <label className="text-xs font-black text-slate-500 uppercase tracking-wider ml-1">BAŞLIK ADI</label>
                            <InputText
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                className="w-full !py-3 !px-4 !rounded-2xl border-slate-200 focus:border-emerald-500 transition-all font-semibold"
                                placeholder="Örn: Kira, Fatura, Personel"
                            />
                        </div>

                        <div className="space-y-2">
                            <label className="text-xs font-black text-slate-500 uppercase tracking-wider ml-1">AÇIKLAMA</label>
                            <InputTextarea
                                value={description}
                                onChange={(e) => setDescription(e.target.value)}
                                rows={4}
                                className="w-full !py-3 !px-4 !rounded-2xl border-slate-200 focus:border-emerald-500 transition-all font-medium"
                                placeholder="Başlık hakkında kısa bir açıklama..."
                            />
                        </div>

                        <div className="flex flex-col sm:flex-row gap-4 pt-4">
                            <Button
                                type="button"
                                label="İPTAL"
                                icon="pi pi-times"
                                className="flex-1 p-button-text !text-slate-500 font-black !py-4 !rounded-2xl hover:!bg-slate-50"
                                onClick={() => navigate("/expenses/categories")}
                            />
                            <Button
                                type="submit"
                                label="KAYDET"
                                icon="pi pi-check"
                                loading={loading}
                                className="flex-[2] !bg-emerald-600 border-none font-black !py-4 !rounded-2xl shadow-lg shadow-emerald-600/20 hover:!bg-emerald-700 transition-all"
                            />
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}
